import React from 'react'
import PropTypes from 'prop-types'

import List  from 'material-ui/List'
import ContentAdd from 'material-ui/svg-icons/content/add'
import FloatingActionButton from 'material-ui/FloatingActionButton'
import CircularProgress from 'material-ui/CircularProgress'
import ChatRoomListItem from './ChatRoomListItem'
import ChatRoomCurrent from './ChatRoomCurrent'
import ChatRoomMembers from './ChatRoomMembers'
import ChatRoomAddOperation from './ChatRoomAddOperation'
import TimeUtils from '../infra/TimeUtils'

import { connect } from 'react-redux'

class ChatRooms extends React.Component {

  static propTypes = {
    userId: PropTypes.string.isRequired,
    userRooms: PropTypes.array
  }

  constructor(props) {
    super(props)
    this.state = {
      userId: props.userId,
      allMembers: [],
      members: [],
      searchFilter: '',
      displayMode: 'grid',
      addingRoom: false,
      currentChatRoomId: ''
    }
  }

  componentDidMount(){
    this.openInitialChatRoom(this.props)
  }
  
  componentWillReceiveProps(nextProps){
    this.openInitialChatRoom(nextProps)
  }

  isLoading() {
    return !this.props.members
        || !this.props.metadata
        || !this.props.userMetadata
        || !this.props.userRooms
        || !this.props.clockOffset
        || !this.props.teamMembers
  }

  openInitialChatRoom = (props) => {
    if (props.userRooms && (!props.userRooms.filter(o => o.dbKey===this.state.currentChatRoomId).length > 0)){
      const roomId = props.userRooms.sort((a, b) => b.lastActTimestamp - a.lastActTimestamp)[0].dbKey
      this.openChatRoom(roomId)
    }
  }

  renderChatRoomsList = () => {

    const items = []
    const clockOffset = this.props.clockOffset.value
    this.props.userRooms
      .sort((a, b) => {
        return b.lastActTimestamp - a.lastActTimestamp
      })
      .forEach((room) => {
        if (this.props.metadata[room.dbKey] && this.props.members[room.dbKey]){

          const metadata = this.props.metadata[room.dbKey].value
          const members = this.props.members[room.dbKey].value

          //TODO move timestamp calculation to ChatRoomListItem component

          const lastTimeStamp = room.lastMessage ? room.lastMessage.timestamp : ''
          const timeStr = lastTimeStamp ? TimeUtils.getTimeStr(clockOffset, lastTimeStamp, 'dynamic') : ''
          const unRead = (room.lastUserActTimestamp < room.lastActTimestamp)
          items.push(<ChatRoomListItem
            key={room.dbKey}
            roomInfo={room}
            thisUser={this.props.userMetadata}
            metadata={metadata}
            lastMessage={room.lastMessage}
            timeStr = {timeStr}
            members={members}
            selected={room.dbKey === this.state.currentChatRoomId}
            unRead={unRead}
            onPress={()=> this.openChatRoom(room.dbKey)}/>)
        }
      })

    return (
      <div
        style={{
          position: 'relative',
          flexGrow: 1,
          display: 'flex',
          flexDirection: 'column',
          width:'inherit'
        }}>
        <div
          style={{
            height: 48, //-2 to take pixel difference into account
            flexShrink: 0,
            backgroundColor:'#F7F7F7',
            flexDirection: 'row',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderBottomStyle: 'solid',
            borderBottomWidth: 1,
            borderBottomColor: '#D3D3D3',
          }}>
          <span
            style={{
              display:'flex',
              fontSize: 16,
              color:'#757575',
            }}>
            Rooms
          </span>

        </div>

        <div
          style={{
            display: 'flex',
            width:'inherit',
            overflow:'auto'
          }}>
          <List
            style={{
              flexGrow:1,
              flexShrink:0,
              paddingTop: 0,
              width:'inherit',
            }}>
            {items}
          </List>
        </div>

        <FloatingActionButton
          style={{
            position: 'absolute',
            marginTop: 'auto',
            marginLeft: 'auto',
            right: 32,
            bottom: 32,
          }}
          onTouchTap={(e) => {
            e.preventDefault()
            this.setState({ addingRoom:true })
          }}>
          <ContentAdd />
        </FloatingActionButton>

      </div>
    )
  }

  openChatRoom(roomId){
    this.setState({
      currentChatRoomId: roomId
    })
  }

  addedChatRoom = (roomId) => {
    this.setState({ addingRoom : false })
    if (roomId){
      this.openChatRoom(roomId)
    }
  }

  renderCurrentChatRoom(){
    const currentRoomId = this.state.currentChatRoomId
    return (<ChatRoomCurrent roomId={currentRoomId}/>)
  }

  renderCurrentChatRoomMembers(){
    const currentRoomId = this.state.currentChatRoomId
    return (<ChatRoomMembers roomId={currentRoomId}/>)
  }

  render() {
    return (
      <div id="content-wrapper"
        style={{
          flexDirection: 'column',
          backgroundColor: 'white',
          display: 'flex',
          width: '100%',
          overflow: 'auto',
        }}>
        <div
          style={{display: 'flex', flexDirection: "row", flex: 1}}>
          <div
            style={{
              width: 300,
              flexShrink:0,
              borderRightStyle: 'solid',
              borderRightWidth: 2,
              borderRightColor: '#D3D3D3',
              display:'flex'
            }}>
            {
              !this.isLoading()
                ? this.renderChatRoomsList()
                : <CircularProgress size={60} thickness={7} color='#527da3' style={{margin: '60px'}}/>
            }
          </div>
          <div
            style={{
              flexGrow: 1,
              flexShrink:1,
              display:'flex',
              justifyContent: 'center',
              borderRightStyle: 'solid',
              borderRightWidth: 2,
              borderRightColor: '#D3D3D3',
            }}>
            {
              !this.isLoading()
                ? this.renderCurrentChatRoom()
                : <CircularProgress size={60} thickness={7} color='#527da3' style={{margin: '60px'}}/>
            }
          </div>
          <div
            style={{
              width: 300,
              display:'flex',
              flexShrink:0,
              overflow: 'auto',
            }}>
            {
              !this.isLoading()
                ? this.renderCurrentChatRoomMembers()
                : <CircularProgress size={60} thickness={7} color='#527da3' style={{margin: '60px'}}/>
            }
          </div>
        </div>

        <ChatRoomAddOperation
          operation="AddRoom"
          addingRoom={this.state.addingRoom}
          onComplete={this.addedChatRoom}/>
      </div>
    )
  }
}

function mapStateToProps(state) {
  //const roomId = ownProps.roomId
  let members = undefined
  let metadata = undefined

  // Get metadata for a particular roomId from props
  if (state.firebase.rooms) {
    const roomMetadata = state.firebase.rooms.metadata
    if (roomMetadata && !roomMetadata.loading) {
      metadata = roomMetadata
    }

    // Get members for a particular roomId from props
    const roomMembers = state.firebase.rooms.members
    if (roomMembers && !roomMembers.loading) {
      members = roomMembers
    }

  }

  return {
    userId: state.firebase.userAuth.id,
    members: members,
    metadata: metadata,
    clockOffset: state.firebase.clockOffset,
    userMetadata: state.firebase.user.metadata,
    userRooms: state.firebase.user.rooms.value,
    teamMembers: state.firebase.team.members
  }
}

export default connect(mapStateToProps)(ChatRooms)



// WEBPACK FOOTER //
// ./src/chat/ChatRooms.js